import { code } from "@spscommerce/utils";

export const SpsAdvancedSearchExamples = {
    basic: {
        label: "Basic Advanced Search",
        description:
            "<p>info about basic advanced searches</p>",
        examples: {
            basic: {
                react: code`
                function Component(props) {
                    const [advSearch, setAdvSearch] = React.useState({
                      isOpen: true,
                      controlsDisabled: false,
                      enteredFields: 1
                    });

                    const [formObj, setFormObj] = React.useState({
                      sender: "",
                      receiver: "Walmart",
                      doctype: "",
                      status: "",
                      archivedDocs: "exclude"
                    });

                    const searchDefaults = {
                      sender: "",
                      receiver: "",
                      doctype: "",
                      status: "",
                      archivedDocs: "exclude"
                    };

                    const [searchText, setSearchText] = React.useState("");
                    const [searchDisabled, setSearchDisabled] = React.useState(true);
                    const handleChange = e => {
                      setSearchText(e.target.value);
                    };

                    function handleToggleAdvancedSearch(value) {
                      setAdvSearch({ ...advSearch, isOpen: value });
                      setSearchDisabled(value);
                    }

                    function handleFormValueChange(e) {
                      const form = { ...formObj };
                      form[e.target.name] = e.target.value;

                      const enteredFields = getEnteredFieldsCount(form);
                      setAdvSearch({ ...advSearch, enteredFields: enteredFields });
                      setFormObj(form);
                    }

                    function handleAdvancedSearchSubmit(form) {
                      console.log(form.elements);
                      console.log(formObj);
                    }

                    function handleAdvancedSearchClear() {
                      setAdvSearch({ ...advSearch, enteredFields: 0 });
                      setFormObj(searchDefaults);
                    }

                    function getEnteredFieldsCount(form) {
                      return Object.keys(form).filter(k => form[k] !== searchDefaults[k]).length;
                    }

                    return (
                      <div>
                        <SpsListToolbar
                          advancedSearch={advSearch}
                          onToggleAdvancedSearch={handleToggleAdvancedSearch}
                        >
                          <SpsListToolbarSearch>
                            <SpsTextInput
                              name="search_text"
                              value={searchText}
                              onChange={handleChange}
                              disabled={searchDisabled}
                              placeholder="Type here to search for something"
                            />
                            <SpsButton kind="icon" icon="search" disabled={searchDisabled} />
                          </SpsListToolbarSearch>
                        </SpsListToolbar>
                        <SpsAdvancedSearch
                          isOpen={advSearch.isOpen}
                          onSubmit={handleAdvancedSearchSubmit}
                          onClear={handleAdvancedSearchClear}
                        >
                          <div className="sps-row">
                            <div className="col-4">
                              <SpsTextInput
                                name="sender"
                                // inputLabel="Sender"
                                value={formObj.sender}
                                placeholder="Enter a sender name"
                                onChange={handleFormValueChange}
                              />
                            </div>
                            <div className="col-4">
                              <SpsTextInput
                                name="receiver"
                                // inputLabel="Receiver"
                                value={formObj.receiver}
                                placeholder="Enter a receiver name"
                                onChange={handleFormValueChange}
                              />
                            </div>
                            <div className="col-4">
                              <SpsTextInput
                                name="doctype"
                                // inputLabel="Document Type"
                                value={formObj.doctype}
                                placeholder="Enter a document type"
                                onChange={handleFormValueChange}
                              />
                            </div>
                            <div className="col-4">
                              <SpsTextInput
                                name="status"
                                // inputLabel="Status"
                                value={formObj.status}
                                placeholder="Enter a status"
                                onChange={handleFormValueChange}
                              />
                            </div>
                          </div>
                        </SpsAdvancedSearch>
                      </div>
                    );
                  }
                `
            }
        }
    },
    disabledButtons: {
        label: "Advanced Search With Disabled Buttons",
        description:
            "<p>info about advanced searches with disabled buttons</p>",
        examples: {
            disabledButtons: {
                react: code`
                function Component(props) {
                    const { "data-testid": testId } = props;
                    const [searchText, setSearchText] = React.useState("");
                    const [advSearch, setAdvSearch] = React.useState({
                      isOpen: true,
                      controlsDisabled: true
                    });
                    const [searchDisabled, setSearchDisabled] = React.useState(true);

                    const handleChange = e => {
                      setSearchText(e.target.value);
                    };
                    function handleToggleAdvancedSearch(value) {
                      setAdvSearch({ ...advSearch, isOpen: value });
                      setSearchDisabled(value);
                    }

                    return (
                      <div>
                        <SpsListToolbar
                          advancedSearch={advSearch}
                          onToggleAdvancedSearch={handleToggleAdvancedSearch}
                        >
                          <SpsListToolbarSearch>
                            <SpsTextInput
                              name="search_text"
                              value={searchText}
                              onChange={handleChange}
                              disabled={searchDisabled}
                              placeholder="Type here to search for something"
                            />
                            <SpsButton kind="icon" icon="search" disabled={searchDisabled} />
                          </SpsListToolbarSearch>
                        </SpsListToolbar>
                        <SpsAdvancedSearch
                          isOpen={advSearch.isOpen}
                          controlsDisabled={advSearch.controlsDisabled}
                        >
                          <i>insert form here</i>
                        </SpsAdvancedSearch>
                      </div>
                    );
                  }
                `
            }
        }
    },
    footerLink: {
        label: "Advanced Search With Footer Link",
        description:
            "<p>info about advanced searches with footer links</p>",
        examples: {
            footerLink: {
                react: code`
                function Component(props) {
                    const [searchText, setSearchText] = React.useState("");
                    const [searchDisabled, setSearchDisabled] = React.useState(false);
                    const [advSearch, setAdvSearch] = React.useState({
                      isOpen: false
                    });

                    const handleChange = e => {
                      setSearchText(e.target.value);
                    };

                    function handleToggleAdvancedSearch(value) {
                      setAdvSearch({ isOpen: value });
                      setSearchDisabled(value);
                    }

                    return (
                      <div>
                        <SpsListToolbar
                          advancedSearch={advSearch}
                          onToggleAdvancedSearch={handleToggleAdvancedSearch}
                        >
                          <SpsListToolbarSearch>
                            <SpsTextInput
                              name="search_text"
                              value={searchText}
                              onChange={handleChange}
                              disabled={searchDisabled}
                              placeholder="Type here to search for something"
                            />
                            <SpsButton kind="icon" icon="search" disabled={searchDisabled} />
                          </SpsListToolbarSearch>
                        </SpsListToolbar>
                        <SpsAdvancedSearch
                          isOpen={advSearch.isOpen}
                          footerLinks={
                            <SpsButton kind="link" icon="gear">
                              Advanced Search Defaults
                            </SpsButton>
                          }
                        >
                          <i>insert form here</i>
                        </SpsAdvancedSearch>
                      </div>
                    );
                  }
                `
            }
        }
    },
    withTitle: {
        label: "Advanced Search With Title",
        description:
            "<p>info about advanced search with title</p>",
        examples: {
            withTitle: {
                react: code`
                function Component(props) {
                    const [advSearch, setAdvSearch] = React.useState({
                      isOpen: true,
                      controlsDisabled: false,
                      enteredFields: 1
                    });

                    const [formObj, setFormObj] = React.useState({
                      sender: "",
                      receiver: "Walmart",
                      doctype: "",
                      status: "",
                      archivedDocs: "exclude"
                    });

                    const searchDefaults = {
                      sender: "",
                      receiver: "",
                      doctype: "",
                      status: "",
                      archivedDocs: "exclude"
                    };

                    function handleToggleAdvancedSearch(value) {
                      setAdvSearch({ ...advSearch, isOpen: value });
                    }

                    function handleFormValueChange(e) {
                      const form = { ...formObj };
                      form[e.target.name] = e.target.value;

                      const enteredFields = getEnteredFieldsCount(form);
                      setAdvSearch({ ...advSearch, enteredFields: enteredFields });
                      setFormObj(form);
                    }

                    function handleAdvancedSearchSubmit(form) {
                      console.log(form.elements);
                      console.log(formObj);
                    }

                    function handleAdvancedSearchClear() {
                      setAdvSearch({ ...advSearch, enteredFields: 0 });
                      setFormObj(searchDefaults);
                    }

                    function getEnteredFieldsCount(form) {
                      return Object.keys(form).filter(k => form[k] !== searchDefaults[k]).length;
                    }

                    return (
                      <div>
                        <SpsListToolbar
                          title="Advanced Search"
                          advancedSearch={advSearch}
                          onToggleAdvancedSearch={handleToggleAdvancedSearch}
                        />
                        <SpsAdvancedSearch
                          isOpen={advSearch.isOpen}
                          onSubmit={handleAdvancedSearchSubmit}
                          onClear={handleAdvancedSearchClear}
                        >
                          <div className="sps-row">
                            <div className="col-4">
                              <SpsTextInput
                                name="sender"
                                // inputLabel="Sender"
                                value={formObj.sender}
                                placeholder="Enter a sender name"
                                onChange={handleFormValueChange}
                              />
                            </div>
                            <div className="col-4">
                              <SpsTextInput
                                name="receiver"
                                // inputLabel="Receiver"
                                value={formObj.receiver}
                                placeholder="Enter a receiver name"
                                onChange={handleFormValueChange}
                              />
                            </div>
                            <div className="col-4">
                              <SpsTextInput
                                name="doctype"
                                // inputLabel="Document Type"
                                value={formObj.doctype}
                                placeholder="Enter a document type"
                                onChange={handleFormValueChange}
                              />
                            </div>
                            <div className="col-4">
                              <SpsTextInput
                                name="status"
                                // inputLabel="Status"
                                value={formObj.status}
                                placeholder="Enter a status"
                                onChange={handleFormValueChange}
                              />
                            </div>
                          </div>
                        </SpsAdvancedSearch>
                      </div>
                    );
                  }
                `
            }
        }
    }
};
